import { Component } from '@theme/component';

/**
 * Tira de marcas en cada colección: al cargar, recorre la tira de lado para que la marca actual
 * quede a la vista en pantallas angostas. No mueve la página de arriba a abajo.
 *
 * @typedef {object} ElifeCollectionLinksRefs
 * @property {HTMLElement} list - La lista que se desliza de lado.
 * @property {HTMLElement | undefined} active - La tarjeta de la marca actual.
 *
 * @extends Component<ElifeCollectionLinksRefs>
 */
class ElifeCollectionLinks extends Component {
  requiredRefs = ['list'];

  connectedCallback() {
    super.connectedCallback();
    this.#revealActive();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#revealActive();
  }

  #revealActive() {
    const { list, active } = this.refs;
    if (!active || list.scrollWidth <= list.clientWidth) return;

    const listRect = list.getBoundingClientRect();
    const activeRect = active.getBoundingClientRect();
    const offset = activeRect.left - listRect.left - (listRect.width - activeRect.width) / 2;
    list.scrollLeft += offset;
  }
}

if (!customElements.get('elife-collection-links')) {
  customElements.define('elife-collection-links', ElifeCollectionLinks);
}
